// src/components/resources/ResourcesSkeleton.js
// Loading skeleton for resource cards

import React from 'react';
import { motion } from 'framer-motion';
import './styles/resources-skeleton.css';

const SkeletonCard = ({ index }) => (
  <motion.div
    className="skeleton-card"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ delay: index * 0.05, duration: 0.3 }}
  >
    <div className="skeleton-card__image">
      <div className="skeleton-card__shimmer" />
    </div>
    <div className="skeleton-card__content">
      <div className="skeleton-card__date" />
      <div className="skeleton-card__title" />
      <div className="skeleton-card__title skeleton-card__title--short" />
      <div className="skeleton-card__meta" />
      <div className="skeleton-card__summary" />
      <div className="skeleton-card__summary skeleton-card__summary--short" />
      <div className="skeleton-card__tags">
        <div className="skeleton-card__tag" />
        <div className="skeleton-card__tag" />
        <div className="skeleton-card__tag" />
      </div>
    </div>
  </motion.div>
);

const ResourcesSkeleton = ({ count = 6 }) => {
  return (
    <section className="resources-skeleton">
      <div className="resources-skeleton__container">
        <div className="resources-skeleton__grid">
          {Array.from({ length: count }).map((_, i) => (
            <SkeletonCard key={i} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ResourcesSkeleton;
